import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import 'echarts-gl';
import { arrayOfObjects3d } from '../../../Mock/MockJson';

const ThreeDBarChart = () => {
    const chartRef = useRef();
    const json = arrayOfObjects3d;

    useEffect(() => {
        const chart = echarts.init(chartRef.current, 'dark');
        const hours = [...new Set(json.map(item => item.Description))]; 
        // const hours = [...new Set(json.map(item => item.DateTime))]; 
        const days = [...new Set(json.map(item => item.Name))]; 

        const data = 
        json.map(item => ({
            // x: hours.indexOf(item.DateTime),
            x: hours.indexOf(item.Description), 
            y: days.indexOf(item.Name),              
            z: item.Value 
        }));
        const option = {
            tooltip: {},
            visualMap: {
                max: Math.max(...json.map(item => item.Value)), 
                inRange: {
                    color: [
                        '#313695', '#4575b4', '#74add1', '#abd9e9',
                        '#e0f3f8', '#ffffbf', '#fee090',
                        '#fdae61', '#f46d43', '#d73027', '#a50026'
                    ]
                },
                textStyle: {
                    color: '#fff'
                }
            },
            xAxis3D: {
                type: 'category',
                data: hours,
                axisLine: { lineStyle: { color: '#bbb' } },
                axisLabel: { color: '#ddd' }
            },
            yAxis3D: {
                type: 'category',
                data: days,
                axisLine: { lineStyle: { color: '#bbb' } },
                axisLabel: { color: '#ddd' }
            },
            zAxis3D: {
                type: 'value',
                axisLine: { lineStyle: { color: '#bbb' } },
                axisLabel: { color: '#ddd' }
            },
            grid3D: {
                boxWidth: 200,
                boxDepth: 80,
                viewControl: {},
                light: {
                    main: { intensity: 1.5, shadow: true },
                    ambient: { intensity: 0.5 }
                }
            },
            series: [
                {
                    type: 'bar3D',
                    data:  data.map(item => ({
                        value: [item.x, item.y, item.z]
                    })),
                    shading: 'lambert',
                    label: {
                        fontSize: 16,
                        borderWidth: 1,
                        color: '#fff'
                    },
                    emphasis: {
                        label: {
                            fontSize: 20,
                            color: '#ff6666'
                        },
                        itemStyle: {
                            color: '#ff4444'
                        }
                    }
                }
            ]
        };

        chart.setOption(option);

        return () => {
            chart.dispose();
        };
    }, []);

    return (
        <div
            ref={chartRef}
            style={{ height: '80%', width: '100%' }}
        ></div>
    );
};

export default ThreeDBarChart;
